<template>
  <div class="empty">
    <van-empty
      class="empty-body"
      :image="require('../image/search_no_data.png')"
      :description="text"
    />
  </div>
</template>

<script>
export default {
  props: {
    text: String,
  },
};
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  height: 100%;
  min-height: 80vh;
  width: 100%;
  .empty-body {
    margin: auto;
    >>> .van-empty__image {
      width: 90px;
      height: 90px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/empty.vue